import React, { Component, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import styles from "./login.module.css";
import LoginImage from "../../assets/images/login-banner.jpg";
import Input from "../../components/Form/LoginInput";
import { setUserSession } from "../../utils/common";
import LogoImage from "../../assets/images/logo.png";
import ReactLoading from 'react-loading';

class Login extends Component {
  state = {
    step: 1,
    isChecked: false,
    email: "",
  };

  componentDidMount() {
    const username = localStorage.getItem("username");
    const checkbox = localStorage.getItem("checkbox");
    if (checkbox && username !== "") {
      this.setState({
        isChecked: true,
        email: localStorage.username,
      });
    }
  }

  onChangeCheckbox = (event) => {
    this.setState({
      isChecked: event.target.checked,
    });
  };

  onChangeValue = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  onClick = (val) => {
    this.setState({
      step: val,
    });
  };

  switchState = () => {
    const { step } = this.state;
    switch (step) {
      case 1:
        return (
          <LoginForm
            onClick={this.onClick}
            onChangeCheckbox={this.onChangeCheckbox}
            onState={this.state}
            onChangeValue={this.onChangeValue}
          />
        );
      // case 2:
      //   return <CheckGSTINComp onClick={this.onClick} />;
      // case 3:
      //   return <CheckPANComp onClick={this.onClick} />;
      // case 4:
      //   return <VerifyGSTDetails onClick={this.onClick} />;
      // case 5:
      //   return <StartSignUpComp onClick={this.onClick} />;
      // case 6:
      //   return <AddressComp onClick={this.onClick} />;
      // case 7:
      //   return <VerifySignUpComp onClick={this.onClick} />;
      // case 8:
      //   return <CheckForgetPasswordComp onClick={this.onClick} />;
      // case 9:
      //   return <VerifyForgetPasswordComp onClick={this.onClick} />;
    }
  };

  render() {
    return <>{this.switchState()}</>;
  }
}

var verifyGSTINDataVar = {};

const LoginApi = (payload, history) => {
  console.log(payload)
  
};


const LoginForm = ({ onClick, onChangeCheckbox, onState, onChangeValue }) => {
  let form = useRef(null);
  const [loading, setLoading] = useState(false)
  let history = useHistory();
  const { refNum } = onState;

  const handleLoginSubmit = (event) => {
    console.log('djsgjsd', process)
    setLoading(true)
    if (refNum !== "") {
      localStorage.setItem("refName", refNum);
    }
    event.preventDefault();
    const form_data = new FormData(form.current);
    let payload = {};
    form_data.forEach(function (value, key) {
      payload[key] = value;
    });

    fetch(`${process.env.REACT_APP_API_ENDPOINT}/group_portal/login`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        if (response.status === 200) {
          let data = await response.json();
          setUserSession(data.token, payload.email, data.exp, data.name);
          localStorage.setItem('UserProfile', JSON.stringify(data));
          history.push("/admin/dashboard");
        } else {
          let data = await response.json();
          if(response.status === 401)
          {
            alert('Incorrect Username or Password');
          } else {
            alert(data.message);
          }
        }
        setLoading(false)
      })
      .catch((err) => err);
  };
  return (
    <section className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-1 overflow-auto h-full">
      <div className="h-full hidden sm:block overflow-auto">
        <img src={LoginImage} className={styles.signinsignup} />
      </div>
      <div className="bg-gray-100 {-- h-screen --} flex justify-center lg:items-center h-full overflow-auto">
        <form
          ref={form}
          onSubmit={handleLoginSubmit}
          className="w-full text-j-magenta pt-2 pl-20 pr-20 pb-2"
        >
          <div className="pt-0 px-2 flex flex-col items-center justify-center">
            <img src={LogoImage } className="h-32 text-center"/>
          </div>
          <div className="pt-4 px-2 flex flex-col items-center justify-center">
            <h3 className="text-2xl sm:text-2xl xl:text-2xl font-bold leading-tight">
              Login To Your Booking
            </h3>
          </div>
          <div className="mt-8 w-full px-2 sm:px-6">
            <div>
              <Input
                id="number"
                name="number"
                placeholder="Number"
                type="text"
                value={refNum}
                onChangeValue={onChangeValue}
              />
            </div>
            <div className="mt-6">
              <Input
                id="password"
                name="password"
                placeholder="Password"
                type="password"
              />
            </div>
          </div>
          <div className="px-2 sm:px-6">
            {loading ? (<div className="flex justify-center pt-4">
              <ReactLoading type={'bubbles'} color={'#500E4B'} /></div>) : <button className="focus:outline-none w-full bg-magenta transition duration-150 ease-in-out hover:bg-j-orange rounded text-white px-8 py-3 text-sm mt-6">
              Login
            </button>}
            {/* <p className="mt-8 text-xs text-center cursor-pointer">
              Don’t Have An Account?{" "}
              <a
                className="underline"
                onClick={() => {
                  onClick(2);
                }}
              >
                Sign Up
              </a>
            </p>
            <p className="mt-6 text-xs text-center">
              <a>
                <sup>*</sup> To Sign - Up you will need a GSTIN/PAN
              </a>
            </p> */}
          </div>
          <div className="flex grid grid-cols-6 text-center gap-4 justify-center mt-4">
            <a
              className="cursor-pointer text-3xl"
              href="https://www.linkedin.com/company/cordelia-cruises/mycompany/?viewAsMember=true"
              target="_blank"
            >
              <i className="fab fa-linkedin"></i>
            </a>
            <a
              href="https://www.facebook.com/cordeliacruises/"
              target="_blank"
              className="cursor-pointer text-3xl"
            >
              <i className="fab fa-facebook-square"></i>
            </a>
            <a
              href="https://www.instagram.com/cordeliacruisesindia/?hl=en"
              target="_blank"
              className="cursor-pointer text-3xl"
            >
              <i className="fab fa-instagram-square"></i>
            </a>
            <a
              href="https://twitter.com/CordeliaCruises"
              target="_blank"
              className="cursor-pointer text-3xl"
            >
              <i className="fab fa-twitter-square"></i>
            </a>
            <a
              href="https://blog.cordeliacruises.com/"
              target="_blank"
              className="cursor-pointer text-3xl"
            >
              <i className="fab fa-blogger"></i>
            </a>
            <a
              href="https://www.youtube.com/channel/UCIGZzyqWsbCH1-VNFsXrY9g"
              target="_blank"
              className="cursor-pointer text-3xl"
            >
              <i className="fab fa-youtube-square"></i>
            </a>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Login;
